import React from 'react';
import TopicsAgentPage from '../components/TopicsAgentPage';
import { API_ENDPOINTS } from '../config/api';
import { TOPICAL_CONTENT_GROUPS } from '../data/topicalContentData';
import { TOPICAL_AGENT_PAGE_DESCRIPTION } from '../config/aiModels';

const NewTopicsAgentPage: React.FC = () => (
  <TopicsAgentPage
    pageTitle="New Topics Agent"
    pageDescription={TOPICAL_AGENT_PAGE_DESCRIPTION}
    storageKeyPrefix="new_topics"
    generateAsyncUrl={API_ENDPOINTS.topicalContentGenerateAsync}
    getJobStatusUrl={API_ENDPOINTS.topicalContentJobStatus}
    staticGroups={TOPICAL_CONTENT_GROUPS}
  />
);

export default NewTopicsAgentPage;
